import {STRING_ROUTE_ORDER_POST} from "../axios";
import {onGetResponseLoadingOrder} from "../../utils/OnGetGoodsForRequestAddForLoadingOrder/onGetGoodsForRequestAddForLoadingOrder";

export const axiosPostAddNewGoodsRouteOrder = async (axiosPrivate, responseLoadingOrder, isBodyRequest, cargoCaseId, getRequestDataToggle, getIdCreateDoc, setErrorMessage, setRouteOrdersBodyRequest) => {
    
    const bodyLoadingOrderString = onGetResponseLoadingOrder(responseLoadingOrder, isBodyRequest)

    const promisesGroup = bodyLoadingOrderString.map(async (el) => {
        const body = {
            exportVGTD: el?.exportVGTD,
            importVGTD: el?.importVGTD,
            grossWeight: el?.grossWeight,
        }
    return await axiosPrivate.post(STRING_ROUTE_ORDER_POST + el.id,
        JSON.stringify(body))
    });
    Promise.all(promisesGroup).then(
        function (response) {
            getRequestDataToggle()
            return new Promise((resolve, reject) => {
                resolve(response)
            })
        }).then(
        function (response) {
            getIdCreateDoc(cargoCaseId)
        }).catch(
        function (error) {
            console.log(error)
        })
    setErrorMessage('');
    setRouteOrdersBodyRequest([]);
}
